import { render, staticRenderFns } from "./StoryItemPage.vue?vue&type=template&id=2da1085a&scoped=true"
import script from "./StoryItemPage.vue?vue&type=script&lang=js"
export * from "./StoryItemPage.vue?vue&type=script&lang=js"
import style0 from "./StoryItemPage.vue?vue&type=style&index=0&id=2da1085a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1085a",
  null
  
)

export default component.exports